import { onFCP } from 'web-vitals/attribution';
import type { FCPMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';

const onFirstContentfulPaint = (report: (m: MetricReport) => void): void => {
  onFCP((metric: FCPMetricWithAttribution) => {
    const a = metric.attribution;
    report({
      name: 'first-contentful-paint',
      value: metric.value,
      unit: 'ms',
      rating: metric.rating,
      navigationType: metric.navigationType,
      id: metric.id,
      delta: metric.delta,
      attribution: {
        kind: 'fcp',
        timeToFirstByte: a?.timeToFirstByte,
        firstByteToFCP: a?.firstByteToFCP,
        loadState: a?.loadState,
      },
    });
  });
};

export default onFirstContentfulPaint;
